<template>
    <v-autocomplete filled outlined dense label="Checklist" hide-details="auto" :items="db.checklists"
        :item-text="displayText" item-value="uuid" v-model="plantilla.refUuid" return-object @change="submit">
        <template v-slot:item="{ item }">
            <div class="checklist-option">
                <div class="checklist-option__title">{{ displayText(item) }}</div>
                <div class="checklist-option__uuid">UUID: {{ item.uuid }}</div>
            </div>
        </template>
        <template v-slot:append-outer class="ma-0">
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" color="info darken-1" size="30" @click="generate"
                        style="cursor: pointer">mdi-file-download-outline</v-icon>
                </template>
                <span>Genera formato de ejemplo con la entidad seleccionada y descarga el
                    fichero</span>
            </v-tooltip>
        </template>
    </v-autocomplete>
</template>

<script>
import moment from 'moment'

export default {
    props: {
        plantilla: {
            type: Object,
            default: () => ({})
        },
    },
    data: () => ({
        db: {
            checklists: []
        }
    }),
    methods: {
        displayText(item) {
            const titulo = item.nombre

            if (item.origenFormato === 'revision') {
                return `${titulo} (Revisión: ${item.revision.uuid})`
            }

            if (item.origenFormato === 'dictamen') {
                return `${titulo} (Dictamen: ${item.dictamen.uuid})`
            }

            const auditoria = item.auditoria
            const cliente = auditoria.cliente.nombreCompleto
            const fechaAuditoria = this.getAuditoriaDateRange(item)
            const contexto = [
                fechaAuditoria,
                cliente,
            ].join(' - ')

            return `${titulo} (${contexto})`
        },
        getAuditoriaDateRange(item) {
            const desde = this.formatDate(item.auditoria.desde)
            const hasta = this.formatDate(item.auditoria.hasta)

            return `${desde} - ${hasta}`
        },
        getCreatedDate(item) {
            return item.createdAt
        },
        formatDate(value) {
            const date = moment(value)
            return date.format('DD/MM/YYYY')
        },
        sortByCreatedAtDesc(items) {
            return [...items].sort((a, b) => {
                return moment(this.getCreatedDate(b)).valueOf() - moment(this.getCreatedDate(a)).valueOf()
            })
        },
        submit() {
            this.$emit('input', this.plantilla)
        },
        generate() {
            this.$emit('generate')
        },

        async getChecklists() {
            if (!this.plantilla.subalcance) return
            let subalcance_uuid = null
            if (typeof this.plantilla.subalcance == 'object')
                subalcance_uuid = this.plantilla.subalcance.uuid
            else subalcance_uuid = this.plantilla.subalcance

            const auditorias = await this.$store.dispatch('auditorias/listBySubalcance', subalcance_uuid)
            const checklistsByAuditoria = await Promise.all(
                auditorias.map(async (auditoria) => {
                    try {
                        const checklists = await this.$store.dispatch('checklists/list', auditoria.uuid)
                        return checklists.map((checklist) => ({
                            ...checklist,
                            auditoria,
                        }))
                    } catch (e) {
                        return []
                    }
                })
            )

            const revisiones = await this.$store.dispatch('revisiones/listBySubalcance', subalcance_uuid)
            const checklistsByRevision = await Promise.all(
                revisiones.map(async (revision) => {
                    const checklists = await this.$store.dispatch('checklists/listByRevision', revision.uuid)
                    return checklists.map((checklist) => ({
                        ...checklist,
                        origenFormato: 'revision',
                        revision,
                    }))
                })
            )

            const dictamenes = await this.$store.dispatch('dictamenes/listBySubalcance', subalcance_uuid)
            const checklistsByDictamen = await Promise.all(
                dictamenes.map(async (dictamen) => {
                    const checklists = await this.$store.dispatch('checklists/listByDictamen', dictamen.uuid)
                    return checklists.map((checklist) => ({
                        ...checklist,
                        origenFormato: 'dictamen',
                        dictamen,
                    }))
                })
            )

            this.db.checklists = this.sortByCreatedAtDesc(
                [].concat(
                    ...checklistsByAuditoria,
                    ...checklistsByRevision,
                    ...checklistsByDictamen
                ).filter(Boolean)
            )
        },

        async init() {
            await this.getChecklists()
        }
    },

    mounted() {
        this.init()
    }
}
</script>

<style scoped>
.checklist-option {
    padding: 4px 0;
    line-height: 1.2;
}

.checklist-option__title {
    font-size: 13px;
    font-weight: 600;
}

.checklist-option__uuid {
    color: #8a8a8a;
    font-size: 12px;
    margin-top: 2px;
}
</style>
